import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import { Switch, Router, Route } from 'react-router-dom';
import createMemoryHistory from 'history/createMemoryHistory';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import jaLocal from 'moment/locale/ja';
import MomentUtils from '@date-io/moment';
import {changeScreenSize} from "./actions";
import 'react-datepicker/dist/react-datepicker.css';


import Menu from './routes/menu';
import Upload from './routes/upload';
import MainList from './routes/main-list';
import DetailList from './routes/detail-list';
import ConsigneeList from './routes/consignee-list';
import ConsigneeListNew from './routes/consignee-list-new';
import ReceiptList from './routes/receipt-list';
import ArrivalList from './routes/arrival-list';
import DeleteList from './routes/delete-list';
import UploadReceipt from './routes/upload-receipt';
import UploadReceiptNew from './routes/upload-receipt-new';
import DecodeProcessList from './routes/decode-process-list'
import EmptyPdf from './routes/empty-pdf';
import Information from './routes/information';
import Faq from './routes/faq';
import Statistics from './routes/statistics';
import StatisticsList from './routes/statistics-list';
import Shipment from './routes/shipment';
import ShipmentDetail from './routes/shipment-detail';
import EntryList from './routes/entry-list';
import EntryDetail from './routes/entry-detail';
import DeliveryStatusList from './routes/delivery-status-list';
import DeliveryStatusDetail from "./routes/delivery-status-detail";
import MappingStep1 from './routes/mapping/step1';
import MappingStep2 from './routes/mapping/step2';
import MappingStep3 from './routes/mapping/step3';
import MappingStep4 from './routes/mapping/step4';
import MasterAddUser from './routes/master/add-user';
import MasterUsers from './routes/master/users';
import SecomSignature from "./routes/master/secom-signature"
import MasterNayose from './routes/master/nayose';
import MasterReceiptsReferences from './routes/master/receipts-references';
import MasterJigyousha from './routes/master/jigyousha';
import MasterKeiyakuKigyou from './routes/master/keiyaku-kigyou';
import MasterAsnCorporateManagement from "./routes/master/asn-corporate-management";
import MasterTrHenkan from './routes/master/tr-henkan';
import MasterAsnHenkan from './routes/master/asncode-henkan';
import MasterHasonhoukokuKbn from './routes/master/hasonhoukoku-kbn';

const store = configureStore();
const history = createMemoryHistory();

const time_limit=30*60*1000; //制限時間
const timer_func = () =>{
	const event = new Event("reloadDisplay");
	window.dispatchEvent(event);
};

let timer_id=setTimeout(timer_func, time_limit);



const theme = createMuiTheme({
	palette: {
		primary: {
			main: '#40bad0',
			contrastText: '#fff',
		},
		secondary: {
			main: '#40bad0'
		},
	},
	typography: {
		useNextVariants: true,
	},
	overrides:{
		TableNoDataCell:{
			cell:{
				zIndex:'1 !important'
			}
		},
		TableFilterCell:{
			flexContainer:{
				flexDirection:'row-reverse',
				'& > button': {
					padding:'5px',
					zIndex:99
				},
				'& > button + div': {
					marginRight:'-30px',
					paddingRight:'30px'
				},
				'& > button:disabled': {
					display:'none'
				},
				'& > button:disabled + div': {
					display:'none'
				},
				'& > div input': {
					fontSize:'80%',
					fontFamily:'inherit',
					paddingBottom : 4,
					height:'auto'
				},
			}
		}
	}
});

window.addEventListener('resize', () => {
	store.dispatch(changeScreenSize({
		windowWidth:window.innerWidth,
		windowHeight:window.innerHeight
	}));
});

const handleClickDocumnet = () =>{
	clearTimeout(timer_id);
	timer_id=setTimeout(timer_func, time_limit);
};

document.addEventListener('keydown',handleClickDocumnet,false);
document.addEventListener('click',handleClickDocumnet,false);

class LocalizedUtils extends MomentUtils {
	getCalendarHeaderText(date) {
		return date.format("YYYY/MM");
	}
	getDatePickerHeaderText(date) {
		return date.format("MM/DD (ddd)");
	}
}

ReactDOM.render(
	<MuiPickersUtilsProvider utils={LocalizedUtils} local={jaLocal}>
		<MuiThemeProvider theme={theme}>
			<Provider store={store}>
				<Router history={history}>
					<Switch>
						<Route path="/master/keiyaku-kigyou/" component={MasterKeiyakuKigyou} />
						<Route path="/master/jigyousha" component={MasterJigyousha} />
						<Route path="/master/nayose" component={MasterNayose} />
						<Route path="/master/receipts-references" component={MasterReceiptsReferences} />
						<Route path="/master/users" component={MasterUsers} />
						<Route path="/master/add-user" component={MasterAddUser} />
						<Route path="/master/secom-signature" component={SecomSignature} />
						<Route path="/master/asncode-henkan" component={MasterAsnHenkan} />
						<Route path="/master/asn-corporate-management" component={MasterAsnCorporateManagement} />
						<Route path="/master/tr-henkan" component={MasterTrHenkan} />
						<Route path="/master/hasonhoukoku-kbn" component={MasterHasonhoukokuKbn} />
						<Route path="/mapping/step4/:divide" component={MappingStep4} />
						<Route path="/mapping/step3/:divide" component={MappingStep3} />
						<Route path="/mapping/step2/:divide" component={MappingStep2} />
						<Route path="/mapping/step1/:divide" component={MappingStep1} />
						<Route path="/entry-detail/:id" component={EntryDetail} />
						<Route path="/entry-list" component={EntryList} />
						<Route path="/delivery-status-Detail" component={DeliveryStatusDetail} />
						<Route path="/delivery-status-list" component={DeliveryStatusList} />
						<Route path="/shipment-detail" component={ShipmentDetail} />
						<Route path="/shipment" component={Shipment} />
						<Route path="/statistics-list" component={StatisticsList} />
						<Route path="/statistics" component={Statistics} />
						<Route path="/faq" component={Faq} />
						<Route path="/information" component={Information} />
						<Route path="/empty-pdf" component={EmptyPdf} />
						<Route path="/delete-list" component={DeleteList} />
						<Route path="/arrival-list" component={ArrivalList} />
						<Route path="/receipt-list" component={ReceiptList} />
						<Route path="/consignee-list-new" component={ConsigneeListNew} />
						<Route path="/consignee-list" component={ConsigneeList} />
						<Route path="/detail-list" component={DetailList} />
						<Route path="/upload/:divide" component={Upload} />
						<Route path="/upload-receipt" component={UploadReceipt} />
						<Route path="/upload-receipt-new" component={UploadReceiptNew} />
						<Route path="/decode-process-list" component={DecodeProcessList} />
						<Route path="/main-list" component={MainList} />
						<Route exact path="/" component={Menu} />
					</Switch>
				</Router>
			</Provider>
		</MuiThemeProvider>
	</MuiPickersUtilsProvider>
    ,document.getElementById('reactRoot'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js